export default () => ({
  async addToCart() {
    const formData = new FormData(this.$root);

    const variant = formData.get("id");
    const productMapTitle = formData.get("properties[_title]");

    const payload = [
      {
        id: Number(variant),
        quantity: Number(this.quantity) || 1,
        ...(productMapTitle ? { properties: { _title: productMapTitle } } : {}),
      },
    ];

    await this.$store.cart.addLines(payload);
  },
});
